import { Button, FormControl, FormLabel, Snackbar } from '@mui/joy';
import { useState } from 'react';
import { useAuth } from '@app/system/context/authContext';
import { validateReconductionsNonRenouvelees } from '@app/api/data/parrainages-reconductions';
import { AppIcon } from '@app/components/AppIcon';

type props = {
    onSuccess: () => void;
    selected: string[];
};

const ValidateReconductionsNonRenouvelees = ({ onSuccess, selected }: props) => {
    const { isGranted } = useAuth();
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState<{
        open: boolean;
        message: string;
        color: 'success' | 'danger';
    }>({ open: false, message: '', color: 'success' });

    // Only show button for ADMIN and USER roles
    const isAdminOrUser = isGranted(['ADMIN', 'USER']);

    if (!isAdminOrUser) {
        return null;
    }

    const handleClick = async () => {
        if (!selected || selected.length === 0) {
            setSnackbar({
                open: true,
                message: 'Veuillez sélectionner au moins une reconduction à valider',
                color: 'danger',
            });
            return;
        }

        const reconductionIds = selected.map((id) => parseInt(id, 10)).filter((id) => !isNaN(id));

        if (reconductionIds.length === 0) {
            setSnackbar({
                open: true,
                message: 'Aucune reconduction valide sélectionnée',
                color: 'danger',
            });
            return;
        }

        if (
            !window.confirm(
                `Êtes-vous sûr de vouloir valider ${reconductionIds.length} reconduction(s) non renouvelée(s) ? Cette action mettra à jour les parrainages liés aux reconductions sélectionnées avec statut "Refus/Reconduction non renouvelée".`
            )
        ) {
            return;
        }

        setLoading(true);
        try {
            const response = await validateReconductionsNonRenouvelees(reconductionIds);
            setSnackbar({
                open: true,
                message: response.data.message || 'Validation effectuée avec succès',
                color: 'success',
            });
            onSuccess();
        } catch (error: any) {
            console.error('Erreur lors de la validation:', error);
            setSnackbar({
                open: true,
                message:
                    error.response?.data?.message ||
                    'Erreur lors de la validation des reconductions',
                color: 'danger',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
         <FormControl  size="sm">
                <FormLabel>Reconductions Non Renouvelées</FormLabel>
                <Button
                variant="soft"
                color="primary"
                size="sm"
                onClick={handleClick}
                loading={loading}
                disabled={!selected || selected.length === 0}
                startDecorator={<AppIcon icon="CheckCircleIcon" />}
            >
                Valider
            </Button>
            </FormControl>
           
            <Snackbar
                open={snackbar.open}
                variant="soft"
                color={snackbar.color}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                {snackbar.message}
            </Snackbar>
        </>
    );
};

export default ValidateReconductionsNonRenouvelees;

